import React, { useEffect } from 'react';
import './psdesinc2024.css';
import { psdesinc2024 } from '../../json/psdesinc2024';

const Psdesinc2024 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Desarrollo Inclusivo 2024"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                Fomentar y apoyar proyectos y actividades creados por y para la comunidad LGBTTTI que promuevan la inclusión, los derechos, la salud y el desarrollo económico inclusivo, de acuerdo con eI Plan Estatal de Desarrollo 2022-2028, dando prioridad a las localidades de alta y muy alta marginación, en pobreza o en los 22 municipios de Atención Prioritaria Indígena del Estado de Hidalgo.
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6><br />
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Fomentar y apoyar proyectos y actividades creados por y para la comunidad LGBTTTI que promuevan la inclusión, los derechos, la salud y el desarrollo económico inclusivo, de acuerdo con el Plan Estatal de Desarrollo 2022-2028, dando prioridad a las localidades de alta y muy alta marginación, en pobreza o en los 22 municipios de Atención Prioritaria Indígena del Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Personas de la comunidad LGBTTTI de los 18 a los 64 años, que cuenten con residencia en Hidalgo, sin acceso a los servicios de salud o atención médica, de las 12 regiones del Estado de Hidalgo de acuerdo con el Plan Estatal de Desarrollo 2022-2028, dando prioridad a localidades de alta y muy alta marginación, en situación de pobreza o en los 22 municipios de atención prioritaria indígena.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                El Programa “Desarrollo Inclusivo” tendrá cobertura en los 84 municipios del Estado de Hidalgo, así como en las 12 regiones, de acuerdo con el Plan Estatal de Desarrollo 2022-2028.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p> 
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Desarrollo Social y Humano<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                Lic. David Robles Hernández: Subsecretario de Desarrollo Social y Humano
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 718 05 64 y 771 107 43 58
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Desarrollo_Inclusivo_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2024</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reformas_ROP_Desarrollo_Inclusivo_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Reforma 02 de febrero de 2024</a>
                </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Convocatorias</h5>
                <ul>
                  <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2024/CONV_DI_J2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Febrero 2024</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2024/CONV_DI_OCT24.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Octubre 2024</a>
                </li>
                </ul><p></p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Formatos</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2024/PDI_2024/SOL_DI_2024-2.docx'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Formato Solicitud de Ingreso al Programa</a>
                </li>

                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2024/PDI_2024/CSE_DI_2024-2.pptx'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Formato Cueestionario Socioeconómico</a>
                </li>

                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2024/PDI_2024/PROY_DI_2024.docx'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Formato Proyecto</a>
                </li>
                </ul>
                
                
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Consulta de folios beneficiados</h5>
                <ul>
                  <li>
                <a
                href='https://amigosdelatransformacion.com.mx/pro.php'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Febrero 2024</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/FOLIOS/BEN_DI_OCT2024.jpeg'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Octubre 2024</a>
                </li>
                </ul>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Enlaces a los catálogos estatal y nacional</h5>
                <ul>
                  <li>
                <a
                href='https://ruts.hidalgo.gob.mx/ver/11201'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Registro Único de Trámites y Servicios (RUTS)</a>
                </li>
                <li>
                <a
                href='https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-019-A'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Catalogo Nacional de Regulaciones Trámites y Servicios (CNARTyS)</a>
                </li>
                </ul>
                </p>
                
              </div>
            </div>
            
          </div>
        </div>
  
      </div>    
    </div>
  );
};

export default Psdesinc2024;